// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"660":"c69805cf9e463252","722":"bc82dd46bcd2b670","985":"83ea3b52cc5943c9"}[chunkId] + ".js";
};